import React from 'react';

import styles from './FillingContainer.module.scss';

export default ({ children }) => (
  <div className={styles.container}>{children}</div>
);
